const trackStandardEvent = (eventName, payload) => {
  var _a;
  (_a = window.fbq) == null ? void 0 : _a.call(window, "track", eventName, payload);
};
const trackMetaPixelAddToCart = (payload) => {
  return trackStandardEvent("AddToCart" /* ADD_TO_CART */, payload);
};
const trackMetaPixelCheckout = (payload) => {
  return trackStandardEvent("InitiateCheckout" /* INITIATE_CHECKOUT */, payload);
};
const trackMetaPixelPurchase = (payload) => {
  return trackStandardEvent("Purchase" /* PURCHASE */, payload);
};
const trackMetaPixelViewContent = (payload) => {
  return trackStandardEvent("ViewContent" /* VIEW_CONTENT */, payload);
};

export { trackMetaPixelAddToCart, trackMetaPixelCheckout, trackMetaPixelPurchase, trackMetaPixelViewContent };
